import { useEffect } from 'react';

import { useAppDispatch } from '@/store';
import { toggleDebugPanel } from '@/store/slices/debug/debugSlice';
import { DEBUG_PANEL_HOTKEY_KEY } from '@/constants';

const TEXT_ENTRY_TAGS = new Set(['INPUT', 'TEXTAREA', 'SELECT']);

function isTextEntryTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  return TEXT_ENTRY_TAGS.has(target.tagName) || target.isContentEditable;
}

export function useDebugPanelHotkey(): void {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent): void => {
      if (!event.ctrlKey) return;
      if (event.key !== DEBUG_PANEL_HOTKEY_KEY && event.code !== 'Slash') return;
      if (isTextEntryTarget(event.target)) return;

      event.preventDefault();
      dispatch(toggleDebugPanel());
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [dispatch]);
}
